<div class="sub-header">
  <div class="container" style="height: 60px;">
    <div class="controls-panel">
      <div class="header">
        <h1>My Account</h1>
      </div>

      <div class="actions">
        <button class="btn btn-rbv warning pull-right" (click)="onChangePassword()">Change Password</button>

        <button *ngIf="currentUrl === 'profile'" class="btn btn-rbv pull-right" (click)="onSave()">
          <fa [name]="'fa fa-save'"></fa> Save
        </button>

        <button *ngIf="currentUrl === 'preferences'" class="btn btn-rbv pull-right" (click)="onSavePreference()">
          <fa [name]="'fa fa-save'"></fa> Save
        </button>

        <!-- <button *ngIf="currentUrl === 'notification'" class="btn btn-rbv pull-right" (click)="onSaveNotification()">
          <fa [name]="'fa fa-save'"></fa> Save
        </button> -->
      </div>

    </div>
  </div>
</div>

<div class="report-header">
  <div class="container">
    <div class="report-header-wrapper">
      <div class="report-menu">
        <div class="wrapper-left">
          <div class="header-item" [routerLink]="['/account', 'profile']" routerLinkActive="active">
            Profile
          </div>

          <!-- <div class="header-item" [routerLink]="['/account', 'preferences']" routerLinkActive="active">
            Preferences
          </div> -->

          <div class="header-item" [routerLink]="['/account', 'notification']" routerLinkActive="active">
            Notifications
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<router-outlet></router-outlet>
